import { Action } from '@ngrx/store';
import { Company } from '../../companies.model';

export enum ActionType {

  ADD_COMPANY = 'ADD_COMPANY',
  ADD_COMPANY_SUCCESS = 'ADD_COMPANY SUCCESS',
  ADD_COMPANY_FAILED = 'ADD_COMPANY FAILED',
  DELETE_COMPANY = 'DELETE_COMPANY',
  DELETE_COMPANY_SUCCESS = 'DELETE_COMPANY SUCCESS',
  DELETE_COMPANY_FAILED = 'DELETE_COMPANY FAILED',
  FETCH_COMPANYS = 'FETCH COMPANYS',
  FETCH_COMPANYS_SUCCESS = 'FETCH COMPANYS SUCCESS',
  FETCH_COMPANYS_FAILED = 'FETCH COMPANYS FAILED',
  UPDATE_COMPANY = 'UPDATE COMPANY',
  UPDATE_COMPANY_SUCCESS = 'UPDATE COMPANY SUCCESS',
  UPDATE_COMPANY_FAILED = 'UPDATE COMPANY FAILED',
  FETCH_COMPANY = 'FETCH COMPANY',
  FETCH_COMPANY_SUCCESS = 'FETCH COMPANY SUCCESS',
  FETCH_COMPANY_FAILED = 'FETCH COMPANY FAILED',
  FETCH_COMPANIES_BY_COMPANYNAME = 'FETCH COMPANIES BY COMPANY NAME',
  FETCH_COMPANIES_BY_COMPANYNAME_SUCCESS = 'FETCH COMPANIES BY COMPANY NAME SUCCESS',
  FETCH_COMPANIES_BY_COMPANYNAME_FAILED = 'FETCH COMPANIES BY COMPANY NAME FAILED',
  UPLOAD_COMPLETED = '[File Upload API] Completed',
  DESTROY_COMPANY = 'DESTROY_COMPANY',
  DESTROY_COMPANY_SUCCESS = 'DESTROY_COMPANY SUCCESS',
  DESTROY_COMPANY_FAILED = 'DESTROY_COMPANY FAILED',

}

export class DestroyCompany implements Action {
  readonly type = ActionType.DELETE_COMPANY;

  constructor(public id: string) { }
}

export class DestroyCompanySuccess implements Action {
  readonly type = ActionType.DELETE_COMPANY_SUCCESS;

  constructor(public id: string) { }
}

export class DestroyCompanyFailed implements Action {
  readonly type = ActionType.DELETE_COMPANY_FAILED;

  constructor() { }
}
export class UploadCompletedAction implements Action {
  readonly type = ActionType.UPLOAD_COMPLETED;
}

export class FetchCompaniesByCompanyName implements Action {
  readonly type = ActionType.FETCH_COMPANIES_BY_COMPANYNAME;
  constructor(public companyName: string) { }
}

export class FetchCompaniesByCompanyNameSuccess implements Action {
  readonly type = ActionType.FETCH_COMPANIES_BY_COMPANYNAME_SUCCESS;
  constructor(public companies: Company[]) { }
}

export class FetchCompaniesByCompanyNameFailed implements Action {
  readonly type = ActionType.FETCH_COMPANIES_BY_COMPANYNAME_FAILED;
  constructor(public error: any) { }
}

export class FetchCompanies implements Action {
  readonly type = ActionType.FETCH_COMPANYS;
  constructor() { }
}

export class FetchCompaniesSuccess implements Action {
  readonly type = ActionType.FETCH_COMPANYS_SUCCESS;
  constructor(public companies: Company[]) { }
}

export class FetchCompaniesFailed implements Action {
  readonly type = ActionType.FETCH_COMPANYS_FAILED;
  constructor(public error: any) { }
}

export class FetchCompany implements Action {
  readonly type = ActionType.FETCH_COMPANY;
  constructor(public companyId: string) { }
}

export class FetchCompanySuccess implements Action {
  readonly type = ActionType.FETCH_COMPANY_SUCCESS;
  constructor(public companies: Company[]) { }
}

export class FetchCompanyFailed implements Action {
  readonly type = ActionType.FETCH_COMPANY_FAILED;
  constructor(public error: any) { }
}

export class AddCompany implements Action {
  readonly type = ActionType.ADD_COMPANY;

  constructor(public company: Company) { console.log('company', company); }
}

export class AddCompanySuccess implements Action {
  readonly type = ActionType.ADD_COMPANY_SUCCESS;

  constructor(public company: Company) { }
}

export class AddCompanyFailed implements Action {
  readonly type = ActionType.ADD_COMPANY_FAILED;

  constructor() { }
}

export class DeleteCompany implements Action {
  readonly type = ActionType.DELETE_COMPANY;

  constructor(public id: string) { }
}

export class DeleteCompanySuccess implements Action {
  readonly type = ActionType.DELETE_COMPANY_SUCCESS;

  constructor(public id: number) { }
}

export class DeleteCompanyFailed implements Action {
  readonly type = ActionType.DELETE_COMPANY_FAILED;

  constructor() { }
}

export class UpdateCompany implements Action {
  readonly type = ActionType.UPDATE_COMPANY;

  constructor(public company: Company) { }
}

export class UpdateCompanySuccess implements Action {
  readonly type = ActionType.UPDATE_COMPANY_SUCCESS;

  constructor(
    public id: string,
    public changes: Partial<Company>,
  ) { console.log('changes' , changes); }
}

export class UpdateCompanyFailed implements Action {
  readonly type = ActionType.UPDATE_COMPANY_FAILED;

  constructor() { }
}

export type CompanyActions =
  AddCompany | AddCompanyFailed | AddCompanySuccess |
  UpdateCompany | UpdateCompanySuccess | UpdateCompanyFailed |
  DeleteCompany | DeleteCompanySuccess | DeleteCompanyFailed |
  FetchCompanies | FetchCompaniesSuccess | FetchCompaniesFailed |
  FetchCompany | FetchCompanySuccess | FetchCompanyFailed |
  FetchCompaniesByCompanyName | FetchCompaniesByCompanyNameSuccess | FetchCompaniesByCompanyNameFailed
  | UploadCompletedAction |
  DestroyCompany| DestroyCompanySuccess | DestroyCompanyFailed;



